import { createRoot } from 'react-dom/client';

import { Api } from './api';

export default async function createShadowDomRoot(rootId: string) {
  const hostElement = document.getElementById(rootId)!;

  // Create shadow DOM
  const shadowRoot = hostElement.attachShadow({ mode: 'open' });

  // Create a container div inside the shadow DOM
  const shadowContainer = document.createElement('div');
  shadowContainer.id = 'shadow-container';
  shadowRoot.appendChild(shadowContainer);

  // Adopt stylesheets from style-loader in webpack to ensure css modules work
  const adoptStyleTag = (style: HTMLStyleElement) => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(style.innerText);
    shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];
  };
  const stylesheetsFromWebpack: NodeListOf<HTMLStyleElement> = document.querySelectorAll('style[spm-webpack-bundled]');
  Array.from(stylesheetsFromWebpack).forEach(adoptStyleTag);

  // Lazy-loaded chunks inject new style tags after this point, so observe and adopt them too
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLStyleElement && node.hasAttribute('spm-webpack-bundled')) {
          adoptStyleTag(node);
        }
      });
    });
  }).observe(document.head, { childList: true });

  const api = new Api();
  const response = await api.fetch('/global_styles.css');
  const style = await response.text();
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(style);
  shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];

  return { reactRoot: createRoot(shadowContainer), shadowContainer };
}
